import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from '../../../components/checkbox/Checkbox';
import styles from './add_watcher_commentaries.module.scss';

type Props = {
  addCommentaryQueryType: () => void;
  removeCommentaryQueryType: () => void;
  isChecked: boolean;
};

export const AddWatcherCommentaries: FC<Props> = ({
  addCommentaryQueryType,
  removeCommentaryQueryType,
  isChecked,
}) => {
  const onClick = () => {
    if (isChecked) {
      removeCommentaryQueryType();
    } else {
      addCommentaryQueryType();
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.checkbox}>
        <Checkbox
          onClick={onClick}
          checked={isChecked}
          dataTestE2e="update-watcher-commentary"
        />
      </div>
      <div className={styles.text}>
        <FormattedMessage id="watchers/components/AddWatcherCommentaries.tsx/1" />
        <div className={styles.info}>
          <FormattedMessage id="watchers/components/AddWatcherCommentaries.tsx/2" />
        </div>
      </div>
    </div>
  );
};
